import { Link } from 'react-router-dom';
import './Pricing.css';

export default function Pricing() {
  return (
    <div className="pricing-page">
      <div className="pricing-header">
        <span className="mono pricing-tag">Simple Pricing</span>
        <h1 className="mono">One plan. All puzzles.</h1>
        <p>Start free. Upgrade when you want more.</p>
      </div>

      <div className="pricing-cards">
        {/* Free */}
        <div className="pricing-card">
          <div className="pricing-card-header">
            <h2 className="mono">Free</h2>
            <div className="pricing-price">
              <span className="price-amount mono">$0</span>
              <span className="price-period mono">/month</span>
            </div>
            <p>Play every day, no credit card needed.</p>
          </div>
          <ul className="pricing-features">
            <li>✅ WordForge daily puzzle</li>
            <li>✅ Streak tracking</li>
            <li>✅ Share your results</li>
            <li className="locked">🔒 GeoForge</li>
            <li className="locked">🔒 MathForge</li>
            <li className="locked">🔒 TriviaForge</li>
            <li className="locked">🔒 LogicForge</li>
            <li className="locked">🔒 Puzzle archive</li>
          </ul>
          <Link to="/register" className="btn-pricing-free mono">Get started free →</Link>
        </div>

        {/* Premium */}
        <div className="pricing-card premium">
          <div className="pricing-badge mono">⚡ Most Popular</div>
          <div className="pricing-card-header">
            <h2 className="mono">Premium</h2>
            <div className="pricing-price">
              <span className="price-amount mono">$4.99</span>
              <span className="price-period mono">/month</span>
            </div>
            <p>Unlock all 5 daily puzzles and more.</p>
          </div>
          <ul className="pricing-features">
            <li>✅ Everything in Free</li>
            <li>✅ GeoForge daily puzzle</li>
            <li>✅ MathForge daily puzzle</li>
            <li>✅ TriviaForge daily puzzle</li>
            <li>✅ LogicForge daily puzzle</li>
            <li>✅ Full puzzle archive</li>
            <li>✅ Hard mode</li>
            <li>✅ Streak protection</li>
            <li>✅ Cancel anytime</li>
          </ul>
          <Link to="/upgrade" className="btn-pricing-premium mono">⚡ Get Premium — $4.99/mo</Link>
        </div>

        {/* Team */}
        <div className="pricing-card team">
          <div className="pricing-card-header">
            <h2 className="mono">Team</h2>
            <div className="pricing-price">
              <span className="price-amount mono">$19.99</span>
              <span className="price-period mono">/month</span>
            </div>
            <p>For teams and offices. Up to 20 members.</p>
          </div>
          <ul className="pricing-features">
            <li>✅ Everything in Premium</li>
            <li>✅ Up to 20 team members</li>
            <li>✅ Team leaderboard</li>
            <li>✅ Admin dashboard</li>
            <li>✅ Priority support</li>
          </ul>
          <a href="mailto:support@puzzleforge.io" className="btn-pricing-team mono">Contact us →</a>
        </div>
      </div>

      <div className="pricing-faq">
        <h2 className="mono">Common questions</h2>
        <div className="faq-grid">
          <div className="faq-item">
            <h3 className="mono">Can I cancel anytime?</h3>
            <p>Yes. Cancel from your account settings. You keep access until the end of your billing period.</p>
          </div>
          <div className="faq-item">
            <h3 className="mono">Is there a refund policy?</h3>
            <p>All sales are final. See our <Link to="/refund">Refund Policy</Link>.</p>
          </div>
          <div className="faq-item">
            <h3 className="mono">How are puzzles generated?</h3>
            <p>All puzzles are generated nightly by Claude AI, so every day brings a fresh challenge.</p>
          </div>
          <div className="faq-item">
            <h3 className="mono">What payment methods?</h3>
            <p>Credit/debit cards and PayPal, processed securely by Paddle.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
